import { createContext } from 'react';

export const EinstellungenSheetContext = createContext<{
  open: boolean;
  setOpen: (open: boolean) => void;
} | null>(null);
